<template></template>

<script setup lang="ts">
import { onMounted } from 'vue';

import { useDeviceStore } from '@/stores/device';
import { isDeviceAOS, isDeviceIOS, isMobile } from '@/utils/native';

const deviceStore = useDeviceStore();

const moveToApp = () => {
	const pathname = window.location.pathname.slice(1);
	const scheme = 'masterpick://' + pathname;

	const handleVisibilityChange = () => {
		if (document.visibilityState === 'hidden') {
			window.history.back();
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		}
	};

	// 먼저 이벤트를 등록합니다.
	document.addEventListener('visibilitychange', handleVisibilityChange);

	setTimeout(() => {
		document.removeEventListener('visibilitychange', handleVisibilityChange);
	}, 2000);

	// location.href 변경 시 발생하는 에러로 인해 위 로직들이 캔슬되는 것을 방지하기 위해 
	// setTimeout으로 분리하여 가장 마지막에 실행합니다.
	setTimeout(() => {
		try {
			window.location.href = scheme;
		} catch (error) {
			console.error(error);
		}
	}, 100);
};

onMounted(() => {
	if (isMobile && deviceStore.getDevice === 'MO' && !isDeviceAOS && !isDeviceIOS) {
		moveToApp();
	}
});
</script>

<style scoped lang="scss"></style>
